module.exports = __webpack_public_path__ + "media/app/images/success_launch-16fdb64c89de076ea4f18955d7ad13ef.png";